import styled, { css } from 'styled-components'

import { FlexCentered, FullWidthHeight } from 'components/common/genericStyles'

export const Wrapper = styled.div`
    cursor: pointer;
    ${FullWidthHeight}
    ${FlexCentered}
    position: relative;
`

export const Menu = {
    Area: styled.div`
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        width: 175px;
        height: max-content;

        position: absolute;
        z-index: 99;
        top: 100%;
        right: 25%;
        transform: translate(0px, 10px);

        /* Black/Primary bg */

        background: #36383c;
        /* Shadows/Desktop/Card base */

        box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.08),
            0px 4px 12px -4px rgba(0, 0, 0, 0.08);
        border-radius: 8px;

        div:first-child {
            border-top-left-radius: inherit;
            border-top-right-radius: inherit;
        }

        div:last-child {
            border-bottom-left-radius: inherit;
            border-bottom-right-radius: inherit;
        }
    `,
    Item: styled.div`
        width: 100%;
        height: 45px;
        display: flex;
        padding: 8px;
        align-items: center;
        cursor: pointer;
        & > * {
            margin: 0px 2.5px;
            cursor: pointer;

            & > * {
                cursor: pointer;
            }
        }

        :hover {
            background: #ffffff24;
        }

        ${props =>
            props.disabled &&
            css`
                opacity: 0.5;
                cursor: not-allowed;
                & > * {
                    cursor: not-allowed !important;
                    & > * {
                        cursor: not-allowed;
                    }
                }
            `}
    `,
    Icon: styled.div`
        width: 15%;
        ${FlexCentered}
        & > img {
            width: 20px;
        }
    `,
    ItemName: styled.div`
        margin-left: 10px;
    `,
}
